﻿import { Tooltip, tooltipClasses } from "@mui/material";
import { styled } from "@mui/system";

const ShepTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    PopperProps={{
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, -5],
          },
        },
      ],
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: "var(--font-sm)",
    fontWeight: "var(--font-semi-bold)",
    color: "var(--primary-main)",
    backgroundColor: "var(--primary-pale)",
    textAlign: "center",
    boxShadow: "var(--shadow-elevation-2)",
    fontFamily: "var(--font-family)",
    padding: "8px",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "var(--primary-pale)",
  },
}));

export default ShepTooltip;
